import { PlatformCommand } from "@shared/commands/command-base";
import { UserModel } from "@shared/models/user.model";

export interface StepByStepProcess {
  id: string;
  steps: Step[];
  isActiveStep: boolean;
  isAllStepsChecked?: boolean;
  title: string;
  isCompleted: boolean;
  command: PlatformCommand;
}

export interface Step {
  id: string;
  title: string;
  description: string;
  isChecked: boolean;
}
export interface ChecklistItem {
  id: string;
  key: string;
  order: number;
  title: string;
  toolTip: string;
  hasWorkflow: boolean;
  hasCommandButton: boolean;
  isMandatory: boolean;
  isExecutionSucceed: boolean;
  isCheckboxEnabled: boolean;
  isHyperlinkEnabled: boolean;
  isWorkflowEnabled: boolean;
  isNavigationCommand: boolean;
  isButtonDisabled: boolean;
  type: string;
  status: CheckStatus;
  workflowName: string;
  commandName: string;
  navigationCommand: PlatformCommand;
  descriptionCommands: {
    [key: string]: PlatformCommand;
  };
  isChecked: boolean;
  commandParameters: {
    [key: string]: any;
  };
  descriptionCommandParameters: {
    [key: string]: any;
  };
  additionalCheckListItems: AdditionalCheckListItem[];
}

export interface JumpRunProgress {
  status: "Running" | "Completed" | "Failed";
  currentWorkflowName: string;
  index: number;
  total: number;
  currentStep: number;
  targetStep: number;
  ranWorkflowNames: string[];
  // On Running, the workflow's own execution view URL; on Completed/Failed, the calculator URL to return to.
  navigateUrl?: string;
  failureMessage?: string;
}

export interface AdditionalCheckListItem {
  commandParameters: {
    [key: string]: any;
  };
  workflowName: string;
  toolTip: string;
}

export enum CheckStatus {
  Pending = "Pending",
  InProgress = "In Progress",
  Completed = "Completed",
}

interface WorksheetStatus {
  workbookName: string;
  worksheetName: string;
  isFormula: boolean;
  isHidden: boolean;
  copyFromAsValue: boolean;
}

export interface ScenarioCalculationStepModel {
  id: string;
  scenarioId: string;
  scenarioType: string;
  countryCode: string;
  reportingEntityCode: string;
  scenarioCalculationId: string;
  createDate: Date;
  createdBy: UserModel;
  modifiedDate: Date;
  modifiedBy: UserModel;
  isDeleted: boolean;
  isOptionalWorkflow: boolean;
  step: number;
  title: string;
  status: string;
  commandName: string;
  commandParameters: {
    [key: string]: any;
  };
  checklists: ChecklistItem[];
  worksheetStatuses: WorksheetStatus[];
  isCalculationModeApplicable: boolean;
  isAllChecked: boolean;
  isCheckboxDisabled: boolean;
  stepCompletedDate: string;
  isMarkAsCompleteDisabled: boolean;
}

// export const dummyStepByStepProcesses: StepByStepProcess[] = [
//     {
//         id: '1',
//         steps: [
//             {
//                 id: '1',
//                 title: 'Step 1',
//                 description: 'Step 1 description',
//                 isChecked: true
//             },
//             {
//                 id: '2',
//                 title: 'Step 2',
//                 description: 'Step 2 description',
//                 isChecked: true
//             },
//             {
//                 id: '3',
//                 title: 'Step 3',
//                 description: 'Step 3 description',
//                 isChecked: true
//             }
//         ],
//         isAllStepsChecked: true,
//         isActiveStep: false,
//         title: 'Step 1',
//         isCompleted: true,
//         command: null
//     }, {
//         id: '2',
//         steps: [
//             {
//                 id: '1',
//                 title: 'Step 1',
//                 description: 'Step 1 description',
//                 isChecked: false
//             },
//             {
//                 id: '2',
//                 title: 'Step 2',
//                 description: 'Step 2 description',
//                 isChecked: false
//             },
//             {
//                 id: '3',
//                 title: 'Step 3',
//                 description: 'Step 3 description',
//                 isChecked: false
//             }
//         ],
//         isAllStepsChecked: false,
//         isActiveStep: true,
//         title: 'Step 2',
//         isCompleted: false,
//         command: null
//     }, {
//         id: '3',
//         steps: [
//             {
//                 id: '1',
//                 title: 'Step 1',
//                 description: 'Step 1 description',
//                 isChecked: false
//             },
//             {
//                 id: '2',
//                 title: 'Step 2',
//                 description: 'Step 2 description',
//                 isChecked: false
//             },
//             {
//                 id: '3',
//                 title: 'Step 3',
//                 description: 'Step 3 description',
//                 isChecked: false
//             }
//         ],
//         isAllStepsChecked: false,
//         isActiveStep: false,
//         title: 'Step 3',
//         isCompleted: false,
//         command: null
//     }
// ]
